export default __webpack_public_path__ + "img/10ac13912f3ecda05b0842fe8fac040c.svg";